/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Navigate, NavLink } from 'react-router-dom';
import { Icon, Select } from '@fnacdarty/back-office-ui';
import Modal from '../Modal';

import {
	getUser,
	isLoggedIn,
	logout,
} from '../../features/authentication/utils/auth';

import {
	getSkills,
	getSectors,
	getResources,
} from '../../features/planning/utils/calendar';
import { getOrganizationList } from '../../features/organization/utils/Organization';

import {
	StyledNavBar,
	StyledAvatar,
	StyledActionList,
	StyledAvatarContainer,
	StyledNavItemContainer,
	StyledNavItem,
	StyledNavigation,
	StyledContainerFilter,
	StyledRefresh,
} from './index.styled';
import logo from '../../assets/images/logos/logo_cuisine_concepteur.png';

const NavBar = ({
	currentTab,
	setChangeFiliale,
	sectors,
	skills,
	resources,
	setRefreshData,
}) => {
	const user = getUser();

	const [isOpen, setIsOpen] = useState(false);
	const [modal, setModal] = useState({
		isOpen: false,
	});

	const AUTH_VAR = `${process.env.REACT_APP_BASE_NAME}`;

	const activeFiltre = window.localStorage.getItem(`${AUTH_VAR}_filiale`)
		? JSON.parse(window.localStorage.getItem(`${AUTH_VAR}_filiale`))
		: null;

	const [selectedValue, setSelectedValue] = useState({
		value: activeFiltre ? activeFiltre?.value : 1,
		label: activeFiltre ? activeFiltre?.label : 'Mes chantiers',
	});

	const [options, setOptions] = useState([]);

	const refreshData = () => {
		setRefreshData(true);
	};

	const logoutModal = () => {
		setModal({ isOpen: true });
	};
	const confirmLogout = async (response) => {
		setModal({ isOpen: false });
		if (response) {
			await logout(() => {});
			window.location.href = '/login';
		}
	};

	const [actions] = useState([
		{
			label: 'Paramètres',
			icon: 'cog',
			action: () => {
				window.location.href = '/settings';
			},
		},
		{
			label: 'Se déconnecter',
			icon: 'logout',
			action: logoutModal,
		},
	]);

	useEffect(() => {
		// handle outisde click
		const handleClickOutside = () => {
			if (isOpen) {
				setIsOpen(false);
			}
		};
		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, [isOpen]);

	useEffect(() => {
		const getFiliale = async () => {
			const res = await getOrganizationList();

			const tab = [
				{
					label: 'Mes chantiers',
					value: 1,
				},
				{
					label: 'Mon magasin',
					value: 2,
				},
			];
			if (res && res.length > 0) {
				res.forEach((element) => {
					tab.push({
						label: element.name,
						value: element.societeCode,
					});
				});
			}

			setOptions(tab);
		};

		getFiliale();
	}, []);

	if (!isLoggedIn()) {
		return <Navigate to="/" />;
	}

	const updateFiliale = (option) => {
		if (option) {
			if (option?.value !== selectedValue.value) {
				setSelectedValue(option);
				window.localStorage.__portail_app_filiale =
					JSON.stringify(option);
				setChangeFiliale(option?.value);
			}
		}
	};

	return (
		<>
			{modal.isOpen && (
				<Modal
					title="Se deconnecter"
					style={{ width: '400px' }}
					onClickCallback={confirmLogout}
				>
					Voulez-vous vraiment vous déconnecter ?
				</Modal>
			)}
			<StyledNavBar>
				<StyledNavigation>
					<div>
						<img src={logo} width={60} />
					</div>

					<StyledNavItemContainer>
						<StyledNavItem $isActive={currentTab === 'activities'}>
							<NavLink to="/activities">Activités</NavLink>
						</StyledNavItem>
						<StyledNavItem $isActive={currentTab === 'planning'}>
							<NavLink to="/planning">Planning</NavLink>
						</StyledNavItem>
					</StyledNavItemContainer>
				</StyledNavigation>

				<StyledAvatarContainer>
					{user?.roles?.length > 0 &&
						user?.roles?.includes('ROLE_CUISINE_INTERNE') &&
						currentTab === 'activities' && (
							<StyledContainerFilter>
								<Select
									options={options}
									selectedValue={selectedValue}
									setSelectedValue={updateFiliale}
									identifier="value"
									value="value"
								/>
							</StyledContainerFilter>
						)}
					<StyledRefresh>
						<Icon name="refresh" onClick={refreshData} />
					</StyledRefresh>
					<StyledAvatar
						onClick={(e) => {
							e.stopPropagation();
							setIsOpen(!isOpen);
						}}
					>
						{user?.firstName[0]}
						{user?.lastName[0]}
					</StyledAvatar>

					<StyledActionList $isOpen={isOpen}>
						{actions.map((action, index) => (
							<li key={index} onClick={action.action}>
								<span>{action.label}</span>
								<Icon name={action.icon} width={24} />
							</li>
						))}
					</StyledActionList>
				</StyledAvatarContainer>
			</StyledNavBar>
		</>
	);
};

NavBar.propTypes = {
	currentTab: PropTypes.string,
	setChangeFiliale: PropTypes.func,
	sectors: PropTypes.func,
	skills: PropTypes.func,
	resources: PropTypes.func,
	setRefreshData: PropTypes.func,
};

export default NavBar;
